// tab-icons.js — the two bottom-tab / top-nav glyphs, captured from iOS canon.
//
// iOS source: Assets.xcassets/Icons/TabBar-Learning.imageset (mortarboard /
// graduation cap with an orange tassel) and TabBar-Playlist.imageset (a list
// of lines with an orange music note). Brief 089 captures ONLY these two; the
// full icon-set inventory (design-doc §7.2 / §12.2) is a separate task.
//
// Design-doc §7.2 forbids substituting generic Material/Heroicons. The iOS
// originals are raster PNGs (no vector source shipped), so these are
// close-fidelity SVG replicas of the same glyphs — flagged for later polish
// against the canonical artwork if a vector source surfaces.
//
// Each glyph has two layers:
//   .body   — fill: currentColor. The tab sets currentColor (white when
//             inactive, orange when active), so the body tracks active-state.
//   .accent — fill: var(--kfe-accent). Always KFE orange, mirroring the iOS
//             icons whose tassel / note stay orange even when unselected.

/** Mortarboard (graduation cap) — the Learning tab. */
export const LEARNING_ICON = `
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path class="body" fill="currentColor" d="M12 3 23 8 12 13 1 8Z"/>
    <path class="body" fill="currentColor"
      d="M5 10.2v4.3c0 1.5 3.1 2.7 7 2.7s7-1.2 7-2.7v-4.3l-7 3.2-7-3.2Z"/>
    <line class="accent" x1="22.3" y1="8.3" x2="22.3" y2="15"
      stroke="var(--kfe-accent)" stroke-width="1.1" stroke-linecap="round"/>
    <circle class="accent" cx="22.3" cy="16.1" r="1.4" fill="var(--kfe-accent)"/>
  </svg>
`;

/** List of lines + music note — the Global Playlist tab. */
export const PLAYLIST_ICON = `
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect class="body" fill="currentColor" x="2" y="5"  width="12" height="2" rx="1"/>
    <rect class="body" fill="currentColor" x="2" y="11" width="12" height="2" rx="1"/>
    <rect class="body" fill="currentColor" x="2" y="17" width="8"  height="2" rx="1"/>
    <g class="accent" fill="var(--kfe-accent)">
      <rect x="18.4" y="5" width="1.6" height="9.4" rx="0.4"/>
      <path d="M20 5c1.7.4 3 1.4 3 3 0-1.7-1.3-2.6-3-2.4Z"/>
      <ellipse cx="17.4" cy="14.6" rx="2.6" ry="2"/>
    </g>
  </svg>
`;
